export default {"src":"/_next/static/media/gray-tooltip.85ff002f.svg","height":12,"width":12};